import { PUBLIC_SECTION_SURFACES } from './publicSectionSurfaces';
import { PublicSectionWaveBottom, PublicSectionWaveTop } from './PublicSectionWave';

/** Parcours : transition gris (Filières) → fond clair, puis vers Tarification. */
export function PublicInscriptionWaveTop() {
  return <PublicSectionWaveTop fill={PUBLIC_SECTION_SURFACES.filieres} />;
}

export function PublicInscriptionWaveBottom() {
  return <PublicSectionWaveBottom fill={PUBLIC_SECTION_SURFACES.tarifsPrograms} />;
}
